import { Table, TableCell, TableHeader } from '@design/components/table';
import { ReactNode } from 'react';

import styles from './SummaryTable.module.scss';

export interface SummaryTableProps {
  title: ReactNode;
  tableHeaders: string[];
  tableRows: {
    fieldName: string;
    consensus?: ReactNode;
    expected?: ReactNode;
    reported: ReactNode;
    surprise: ReactNode;
    surprisePercent?: ReactNode;
  }[];
}

export const SummaryTable = ({
  title,
  tableHeaders,
  tableRows,
}: SummaryTableProps) => {
  const renderCell = (key: string, value?: ReactNode) => {
    if (key === 'fieldName') {
      return (
        <TableHeader
          className={styles.styledTableHeader}
          key={key}
          isHoverEnabled={false}
          alignment={'left'}
        >
          <span className={styles.styledRowHeaderLabel}>{value}</span>
        </TableHeader>
      );
    }

    return (
      <TableCell
        className={styles.styledTableCell}
        key={key}
        isNumber
        data-testid={`${key}-cell`}
      >
        {value}
      </TableCell>
    );
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <Table
        className={styles.styledTable}
        withBodyRowHover={false}
        TableHeaderContent={
          <tr>
            {tableHeaders.map((name, idx) => (
              <TableHeader
                className={styles.styledTableHeader}
                key={name}
                isHoverEnabled={false}
                alignment={idx === 0 ? 'left' : 'right'}
              >
                <span>{name}</span>
              </TableHeader>
            ))}
          </tr>
        }
        TableBodyContent={tableRows.map(data => (
          <tr key={data.fieldName}>
            {Object.entries(data).map(([key, value]) => {
              return renderCell(key, value);
            })}
          </tr>
        ))}
      />
    </div>
  );
};
